<template>
  <section v-if="product.type === 'AndroidGame'" class="mt-5" itemscope itemtype="http://schema.org/MobileApplication">
    <h4>{{ $t('product.androidPermissions', {product: this.globalResources.productTranslation.Single}) }}</h4>
    <b-badge v-for="permission in product.androidPermissions" :key="permission.id" variant="light" class="mx-1" itemprop="permissions">
      {{ permission }}
    </b-badge>
  </section>
</template>

<script>
export default {
  name: 'ProductPermissions',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
